export default __webpack_public_path__ + "static/media/proclamation8.1c225acc.jpg";